import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { FeatureFlagsAndLimitsState } from '../../data-access/store/state';
import { selectDowntime } from '../../data-access/store/selectors';

@Component({
  selector: 'bb-total-downtime-page',
  templateUrl: './total-downtime-page.component.html',
  styleUrls: ['./total-downtime-page.component.scss'],
})
export class TotalDowntimePageComponent implements OnInit {
  bannerMessage = '';
  description = '';

  constructor(
    private store: Store<FeatureFlagsAndLimitsState>
  ) { }

  ngOnInit(): void {
    this.store.select(selectDowntime).subscribe((downtime) => {
      this.bannerMessage = downtime?.bannerMessage ?? '';
      this.description = downtime?.descriptionText ?? '';
    })
  }
}
